import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const Frame = ({ src, alt, caption, meta, testid }) => (
  <figure data-testid={testid} className="group">
    <div className="overflow-hidden rounded-md border border-[#1c4431]/20">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
    </div>
    <figcaption className="mt-4 flex items-baseline justify-between gap-4">
      <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#1f5c3d]">
        {caption}
      </span>
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8a9481]">
        {meta}
      </span>
    </figcaption>
  </figure>
);

export default function Results() {
  return (
    <section
      id="results"
      data-testid="results-section"
      className="mx-auto max-w-7xl px-4 py-24 sm:px-8 md:py-32 lg:px-16"
    >
      <SectionHeading
        overline="04 / Proof, not promises"
        title="From slurry to lawn."
        testid="results-heading"
      />
      <div className="grid gap-10 md:grid-cols-2 md:gap-8">
        <Reveal>
          <Frame
            src="/work3.jpg"
            alt="Dusk hydroseeding pass beside a log home with the Pratt's truck on site"
            caption="Dusk pass — log home site"
            meta="Spray day"
            testid="results-frame-spray"
          />
        </Reveal>
        <Reveal delay={0.15}>
          <Frame
            src="/work1.jpg"
            alt="A hydroseeded slope weeks later covered in thick established green turf"
            caption="Weeks later — established turf"
            meta="Grown in"
            testid="results-frame-after"
          />
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <div className="mt-14 flex justify-center">
          <Link
            to="/before-after"
            data-testid="results-gallery-link"
            className="group flex items-center gap-3 rounded-full bg-[#1f5c3d] px-8 py-4 font-mono text-sm font-bold uppercase tracking-widest text-[#f6f1e3] transition-colors duration-300 hover:bg-[#2a7452]"
          >
            See every before & after
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
